export default __webpack_public_path__ + "static/media/calendar_in_num_1.f8ac36bd.png";